/**
 * Enum HKWorkoutActivityType imported from HealthKit.framework and converted to TypeScript
 * To find it, either directly from: HealthKit.framework/Headers/HKWorkout.h
 * Or: Command-click on any HKWorkoutActivityType reference in Swift code,
 * Xcode will open the header file showing all enum values
 */
export enum AppleHKWorkoutActivityType {
  americanFootball = 1,
  archery = 2,
  australianFootball = 3,
  badminton = 4,
  baseball = 5,
  basketball = 6,
  bowling = 7,
  boxing = 8,
  climbing = 9,
  cricket = 10,
  crossTraining = 11,
  curling = 12,
  cycling = 13,
  dance = 14,
  danceInspiredTraining = 15,
  elliptical = 16,
  equestrianSports = 17,
  fencing = 18,
  fishing = 19,
  functionalStrengthTraining = 20,
  golf = 21,
  gymnastics = 22,
  handball = 23,
  hiking = 24,
  hockey = 25,
  hunting = 26,
  lacrosse = 27,
  martialArts = 28,
  mindAndBody = 29,
  mixedMetabolicCardioTraining = 30,
  paddleSports = 31,
  play = 32,
  preparationAndRecovery = 33,
  racquetball = 34,
  rowing = 35,
  rugby = 36,
  running = 37,
  sailing = 38,
  skatingSports = 39,
  snowSports = 40,
  soccer = 41,
  softball = 42,
  squash = 43,
  stairClimbing = 44,
  surfingSports = 45,
  swimming = 46,
  tableTennis = 47,
  tennis = 48,
  trackAndField = 49,
  traditionalStrengthTraining = 50,
  volleyball = 51,
  walking = 52,
  waterFitness = 53,
  waterPolo = 54,
  waterSports = 55,
  wrestling = 56,
  yoga = 57,
  barre = 58,
  coreTraining = 59,
  crossCountrySkiing = 60,
  downhillSkiing = 61,
  flexibility = 62,
  highIntensityIntervalTraining = 63,
  jumpRope = 64,
  kickboxing = 65,
  pilates = 66,
  snowboarding = 67,
  stairs = 68,
  stepTraining = 69,
  wheelchairWalkPace = 70,
  wheelchairRunPace = 71,
  taiChi = 72,
  mixedCardio = 73,
  handCycling = 74,
  discSports = 75,
  fitnessGaming = 76,
  cardioDance = 77,
  socialDance = 78,
  pickleball = 79,
  coolDown = 80,
  swimBikeRun = 82,
  transition = 83,
  underwaterDiving = 84,
  other = 3000,
}
